<template>
  <TableCommon title="角色信息" :show-custome="false">
    <el-checkbox-group v-model="roles">
      <el-checkbox label="CRM000">售达方</el-checkbox>
      <el-checkbox label="CRM002">收货方</el-checkbox>
      <el-checkbox label="CRM004">收票方</el-checkbox>
    </el-checkbox-group>
  </TableCommon>
</template>

<script>
export default {
  props: {
    role: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      roles: []
    }
  },
  created() {
    this.roles = this.role.map(v => v.RLTYP)
  },
  methods: {
    submitForm() {
      const result = []
      if (!this.roles.length) return result

      this.roles.forEach(v => {
        result.push({
          RLTYP: v,
          RLCTXT: '',
          RLCTITLE: ''
        })
      })
      return result
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/client-manage/components/Role.vue